import { styled } from '@mui/material/styles'
import { Menu } from '@mui/material'

export const MenuMui = styled(Menu)({
    '& .MuiPopover-paper': {
        background: '#121212',
        width: '14rem',
        maxWidth: '100%',
    },

    '& .MuiList-root ul': {
        '&:focus-visible': {
            outline: 'none',
        },
    },

    '.MuiMenuItem-root': {
        transition: 'background 0.3s ease-in-out',

        '&:hover': {
            background: 'rgba(112,112,112,.5)',
            transition: 'background 0.3s ease-in-out',
        },
    },

    '.MuiListItemIcon-root, .MuiListItemText-root': {
        fontSize: '1.25rem',
        color: '#fff',
        textDecoration: 'none',
    },

    '.MuiListItemText-root': {
        color: '#fff',
        textDecoration: 'none',
    },

    'a.drop-link': {
        all: 'unset',
        height: '2rem',
        cursor: 'pointer',
        textDecoration: 'none',
    },

    '.MuiDivider-root': {
        background: 'rgba(255, 255, 255, 0.12)',
    },
})
